import { isEmpty } from 'ramda'

import Loading from 'app/common/components/Loader'
import EmptyWarn from 'app/common/layouts/EmptyWarn'
import Tile, { TileType } from 'app/common/templates-next/tile-template/tile'

import { getReportTitle, getReportDescription } from './availableReports'
import { ReportFavoritesSwitcher } from '../common/reports/ReportFavoritesSwitcher'
import { useFinancesReportsEnabled } from './useFinancesReportsEnabled'

import styles from './FinancesRoot.scss'

type Props = {
  createLink: (reportKey: string) => string
}

const FinancesRoot = ({ createLink }: Props) => {
  const { reportsEnabled, loading } = useFinancesReportsEnabled()

  if (loading) {
    return <Loading />
  }

  const nothing = isEmpty(reportsEnabled)
  if (nothing) {
    return <EmptyWarn className={styles.emptyWarn}>{'Нет доступных отчетов'}</EmptyWarn>
  }

  return (
    <div className={styles.root}>
      {reportsEnabled.map((reportKey) => {
        return (
          <Tile
            key={reportKey}
            type={TileType.Report}
            link={createLink(reportKey)}
            title={getReportTitle(reportKey)}
            info={getReportDescription(reportKey)}
            linkButtonTitle="Открыть отчет"
            showMoreButton
          >
            <ReportFavoritesSwitcher reportKey={reportKey} />
          </Tile>
        )
      })}
    </div>
  )
}

export default FinancesRoot
